<template>
<div v-cloak class="transfer-right-body" id="cloudTransfer" v-if="transferPageShow" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.05)">
    <div class="task-top">
        <div class="task-top-position">
            <div class="transfer-name">{{$t('language.teamTransfer.teamTransfer')}}</div>
            <div class="transfer-description">{{$t('language.teamTransfer.transferMultiple')}}
                <span class="icon-util question-mark question-mark-position">
                      <div :class="$i18n.locale=='france'?'up-prompt':'up-prompt'">{{$t('language.teamTransfer.businessCloud')}}</div>
                </span>
            </div>
        </div>
    </div>
    <div class="task-middle">
        <div class="team-box-position">
            <div class="team-transfer-box" :class='boxFrom' >
               
                <div style="height:100%;" >
                    <div class="team-box-title"  >
                        <div>
                             <div class="title-txt-team task-operating-none" >{{$t('language.cloudTransfer.from')}}</div>
                             <div class="team-refresh icon-util edit" v-if="fromDrives.length" @click="transferSourceDialogShow('inner')"></div>
                        </div>
                    </div>
                   
                    <div class="team-box-body" v-if="fromDrives.length">
                         <div class="team-box-item" style="height:50Px;float:left;width:100%">
                               <div class="task-type task-icon icon-normal-drive" :class="[fromDrives.length?fromDrives[0].appName+'_big':'']"></div>
                               <div class="source-title" >{{fromDrives[0].name}}</div>   
                         </div>
                          <el-scrollbar style="height:calc(100% - 50Px);width:100%">
                         <ul :key="index" class="team-box-item team-box-all" v-for="(item,index) in fromDrives[0].data.members">      
                              <div class="item-line"  @click.stop="open(item)">
                             <div style="cursor: pointer;width:7%;left:10Px"   @click.stop="open(item)" class="icon-util not-open-position pull-triangle-position " :class="[item.open?'down-triangle down-triangle-position':'pull-triangle']"></div>
                             <div style="cursor: pointer;width:82%;left:10Px;position:relative;"  @click.stop="open(item)"  @dblclick.stop="open(item)" class='box-litem' :title="item.domain"> {{item.domain}}  </div>
                               </div>        
                             <ul  v-show="item.open" class="team-box-item" :key="index" v-for="(litem,index) in item.items">
                                <div class="item-line" @click.stop="checkSource(litem)">
                                 <span @click.stop="checkSource(litem)" :class="[checkSourceItem == litem?'check-radio':'radio']"   class="icon-util  team-radio-position" style="margin-left:8%;float:left;top:14Px;"></span>
                                 <div @click.stop="checkSource(litem)" class='box-litem' :title="litem.email"> {{litem.email}} </div>
                                 </div>
                             </ul>
                            
                         </ul>
                           </el-scrollbar>
                    </div>
                   
                    <div v-if="!fromDrives.length" class="add-transfer-txt team-cursor" @click="transferSourceDialogShow('out')" >
                        <div class="add-team-transfer add-team-icon-position" ></div>
                        <div class="cloud-txt">{{$t('language.teamTransfer.sourceCloud')}}</div>
                    </div>
                 
                </div>
               
            </div>
            <!-- 中间的大框 -->
            <div class="team-task-box-middle" v-loading="autoLoading">
                 <div class="team-box-title">
                      <div class="team-title-item" style="padding-left:10px;width:45%;">{{$t('language.teamTransfer.sourceAccount')}}</div>
                      <div class="team-title-item">{{$t('language.teamTransfer.targetAccounts')}}</div>
                      <div class="team-last-item">
                           <div  @click="deletePair()"  style="float:right;width:10%;">
                           <div  class="team-icon-position trash-position" :class="[pair.length?'delete':'delete-dis']" ></div>
                           <!-- <div :class="[!fromDrives.length||!aimDrives.length||!pair.length?'trash-icon-dis':'trash-icon']">{{$t('language.cloudExploer.trash')}}</div> -->
                           </div>
                             <div class="auto-all" >
                           
                          <!-- <div> -->
                          <div class="trash-right" >
                          </div>
                          <div style="width:20%;float:right;">
                           <div class=" dropdown-icon "  @mouseover="showMenu()" @mouseleave="showDown=true,boxmenuShow=false;" :class="getDropDown()"  style="position:relative;top:6Px;float:right;left:-8px;">

                           </div>
                           </div>
                            <div   @mouseover="showMenu()" @mouseleave="showDown=true,boxmenuShow=false;;" :class="[!fromDrives.length||!aimDrives.length||autoLoading?'auto-match-dis':'auto-match']" :title="$t('language.teamTransfer.batchMatch')">
                               {{$t('language.teamTransfer.batchMatch')}}
                               <div class="csv-box" v-show="boxmenuShow">
                                    <div class="csv-item" @click.stop="autoMatch()" :title="$t('language.teamTransfer.autoMatch')">{{$t('language.teamTransfer.autoMatch')}}</div>
                                    <div class="csv-item" @click.stop="openUpload()" :title="$t('language.teamTransfer.uploadCSV')">{{$t('language.teamTransfer.uploadCSV')}}
                                         <input type="file" id="openFile" ref="uploadFile"  style="display:none;"  @change="clickUploadFileChange($event)" />
                                    </div>
                                    <div class="csv-item" @click.stop="downLoad()" :title="$t('language.teamTransfer.downloadCSV')">{{$t('language.teamTransfer.downloadCSV')}}</div>
                               </div>
                           </div>
                           <!-- <div  @mouseover="showMenu()" @mouseleave="showDown=true,boxmenuShow=false;;" class=" team-icon-position" style="float:right;" :class="[!fromDrives.length||!aimDrives.length||autoLoading?'team-transfer-blue-dis':'team-transfer-blue']" ></div> -->
                         <!-- </div> -->
                         </div>
                      </div>
                 </div>
             
                 <div class="team-box-middle-body" id="data-list-content">
                 <div class="middle-box" :class="hoverIndex==index?'middle-box-background':''"  @mouseover="hoverIndex=index" @mouseleave="hoverIndex=-1" :key="index" v-for="(item,index) in pair">
                      <div class="team-title-item" style="padding-left:10px;width:45%;"><span class="icon min-type-position"  v-if="item.from" :class="fromDrives[0].appName+'-small'"></span><span v-if="item.from">{{item.from}}</span></div>
                      <div class="team-title-item"><span class="icon min-type-position" v-if="item.to"  :class="aimDrives[0].appName+'-small'"></span><span v-if="item.to">{{item.to}}</span></div>
                      <div class="team-last-item"><div class="icon-util team-transfer-close" v-if="hoverIndex==index"  @click="cliclRemoveItem(index)"></div></div>
                 </div>
                 </div>
               
            </div>

            <div class="team-transfer-box" :class='boxTo'>
                 <div style="height:100%;">
                    <div class="team-box-title" >
                         <div >
                              <div class="title-txt-team task-operating-none" >{{$t('language.cloudTransfer.to')}}</div>
                              <div class="team-refresh icon-util edit" v-if="aimDrives.length" @click="transferAimDialogShow('inner')"></div>
                         </div>
                    </div>
                      <div class="team-box-body" v-if="aimDrives.length">
                         <div class="team-box-item" style="height:50Px;float:left;width:100%">
                               <div class="task-type task-icon icon-normal-drive" :class="[aimDrives.length?aimDrives[0].appName+'_big':'']"></div>
                               <div class="source-title" >{{aimDrives[0].name}}</div>   
                         </div>
                            <el-scrollbar style="height:calc(100% - 50Px);width:100%">
                         <ul class="team-box-item team-box-all" :key="index" v-for="(item,index) in aimDrives[0].data.members">
                              <div class="item-line" @click.stop="openAim(item)">
                             <div  style="cursor: pointer;width:7%;left:10Px" @click.stop="openAim(item)" class="icon-util  pull-triangle-position not-open-position " :class="[item.aimOpen?'down-triangle  down-triangle-position':'pull-triangle']"></div>
                             <div  style="cursor: pointer;width:82%;left:10Px;position:relative;" @click.stop="openAim(item)" @dblclick.stop="openAim(item)" class='box-litem' :title="item.domain">{{item.domain}}</div>
                              </div>
                             <ul  v-show="item.aimOpen" class="team-box-item" :key="index" v-for="(litem,index) in item.items">
                                   <div class="item-line"  @click.stop="checkAim(litem)">
                                    <span @click.stop="checkAim(litem)" :class="[checkAimItem == litem?'check-radio':'radio']"   class="icon-util  team-radio-position" style="margin-left:8%;float: left;top:14Px;"></span>
                                    <div @click.stop="checkAim(litem)" :title="litem.email" class="box-litem"> {{litem.email}} </div>
                               
                                   </div> 
                             </ul>
                         </ul>
                         </el-scrollbar>
                    </div>
                    <div v-else class="add-transfer-txt  team-cursor"  @click="transferAimDialogShow('out')">
                          <div class="add-team-transfer add-team-icon-position" style="float:left;"></div>
                          <div class="cloud-txt">{{$t('language.teamTransfer.targetCloud')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="team-definite-operating">
            <div style="position:relative;">
            <div class="operating-options" @click="openOptionsDialog()">
                <div class="icon-util setting" style="float:left;"></div>
                <div class="operating-position">{{$t('language.common.options')}}</div>
            </div>
            <div class="operating-schedule" @click="openSchduleDialog()">
                <div class="icon-util" @click.stop="checkedOpen()" :class="checkedSchedule?'check':'nocheck'" style="float:left;"></div>
                <div class="operating-position">{{$t('language.common.schedule')}}</div>
            </div>
            <edit-input ref="editInput" :inputValue=inputValue :submitTaskName="submiTransfertName" ></edit-input>
            <button class="transfer-button" v-if="!checkedSchedule" @click="transferNow()">
                <div class="icon transfer-icon-position teamTransfer"></div>
                <div style="float:left;">{{$t('language.cloudTransfer.transferNow')}}</div>
            </button>
            <div class="schedule-button" v-if="checkedSchedule" @click.stop="transferAddTask()">
                <div class="text-button-position">
                    <div class="icon transfer-task-position cloudTransfer"></div>
                    <div style="float:left;color:#fff;">{{$t('language.cloudTransfer.addTaskOnly')}}</div>
                </div>
                <div class="more-button-position" @click.stop="addTaskIconShow()">
                    <div class="icon-util  transfer-up-position" :class="addTaskShow?'transfer-up':'transfer-down'"></div>
                </div>
            </div>
            <div class="addTask" v-if="addTaskShow" @click.stop="addTransferNow()">
                <div class="task-type-icon-min transfer-blue-min transfer-blue-position"></div>
                <div style="float:left;">{{$t('language.cloudTransfer.addTaskNow')}}</div>
            </div>
            <transition name="flow">
                <div class="flow-icon" v-show="flowShow" id="transferFlow">
                    <div class="icon transfer-task-position teamTransfer flow-icon-position"></div>
                </div>
            </transition>
        </div>
        </div>
    </div>
    <div class="task-buttom"></div>
    <transferAimsDialog ref="transferAimsDialog"></transferAimsDialog>
    <transferSourceDialog ref="transferSourceDialog"></transferSourceDialog>
    <transferOptionsDialog ref="transferOptionsDialog"></transferOptionsDialog>
    <transferScheduleDialog ref="transferScheduleDialog"></transferScheduleDialog>
    <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    <noticeDialog ref="noticeDialog"></noticeDialog>
    <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
    <teamNotice ref="teamNotice"></teamNotice>
    <uploadCSV ref="uploadCSV"></uploadCSV>
</div>
</template>

<script>
//显示账号升级弹窗
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import commonUtils from "@/js/workspace/common_util.js";
import transferAimsDialog from "@/components/popup/cloud_transfer_popups/task_single_popup";
import transferSourceDialog from "@/components/popup/cloud_transfer_popups/team_transfer_source_popup.vue";
import transferOptionsDialog from "@/components/popup/cloud_transfer_popups/transfer_options_popup";
import transferScheduleDialog from "@/components/popup/cloud_transfer_popups/task_schedule_popup";
import editInput from '@/components/common/input/edit_input';
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import taskListUtils from "@/js/workspace/task_list_util.js";
import noticeDialog from "@/components/popup/cloud_transfer_popups/transfer_notice_popup";
import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
import commonstate from '@/js/constant.js';
import axios from 'axios';
//导入提示弹窗
import teamNotice from '@/components/popup/team_transfer_popups/team_transfer_notice_popups';
//导入上传弹窗
import uploadCSV from '@/components/popup/team_transfer_popups/upload_csv_popups.vue';
export default {
  name: "cloudTransfer",
  components: {
    transferAimsDialog,
    transferSourceDialog,
    "edit-input": editInput,
    transferOptionsDialog,
    transferScheduleDialog,
    upgradeNewDialog,
    noticeDialog,
    remindBindEmailDialog,
    teamNotice,
    uploadCSV
  },
  data () {
    return {
      flowShow: false,
      transferPageShow: true,
      singleDrives: {},
      mulitDrives: [],
      hasSelect: true,
      hasSelectItemsMore: false,
      hasSelectItems: false,
      inputValue: commonUtils.getTaskTxt(this),
      checkedSchedule: false,
      hoverCurrent: -1,
      allLength: 0,
      folderType: 'small-file type-icon-position',
      fileType: 'icon type-drive-position',
      addTaskShow: false,
      pOptions: {
        replace: 2,
        isChar: 1,
      },
      pSchedules: {},
      boxFrom: '',
      boxTo: '',
      addTaskFlag: true,
      loading: false,//
      fromDrives: [],//选择的源云盘
      aimDrives: [],//选择的目标云盘
      sourceOpen: false,//是否打开源文件
      checkSourceItem: null,//用户选中的项
      checkAimItem: null,//用户选择的目标项
      pair: [],
      haveClickUpload: false,//是否已经点过长传弹窗
      autoLoading: false,//当自动匹配时就会显示loading
      hoverIndex: -1,
      pairCopyValue: [],
      showDown: true,//是否显示向下箭头
      boxmenuShow: false,
    };
  },
  watch: {
    //监听任务列表，默认名称跟着变化
    '$store.state.taskListArr': function (newValue, oldValue) {
      let allTasklistData = this.$store.state.taskListArr;
      commonUtils.changeTaskNameLength(allTasklistData, this);
    },
    'pair':function(newValue,oldValue){
        this.$nextTick(() => {
    var div = document.getElementById('data-list-content');
    div.scrollTop = div.scrollHeight;
  })
    }
  },
  created () {
    //初始化界面名称
    commonUtils.initPageName(this, 'cloudTransfer');
    // this.fromDrives = [{"data":{"members":[{"domain":"test","open":true,"items":[]}]}}];
    // for(let i=0;i<4001;i++){
    //   this.fromDrives[0].data.members[0].items.push({
    //     "id": "feedback@multcloud.com:root",
    //     "name": "Feedback MultCloud",
    //     "dir": true,
    //     "email": i+"feedback@multcloud.com",
    //     "writeable": false})
    // }
    // console.log(this.fromDrives[0])
  },
  mounted () {
    //禁用拖拽功能
    commonUtils.dragDisAble('cloudTransfer', this);
  },
  methods: {
    onDrag: function (e) {
      e.stopPropagation();
      e.preventDefault();
    },
    addTaskIconShow () {
      this.addTaskShow = !this.addTaskShow;
    },
    cliclRemoveItem (index) {
        if(!this.pair[index].from || !this.pair[index].to){
           this.checkSourceItem=null;
           this.checkAimItem=null;
        }
           this.pair.splice(index, 1);
    },
    showMenu () {
      if (!this.fromDrives.length || !this.aimDrives.length) {
        return
      }
      this.showDown = false;
      this.boxmenuShow = true;
    },
    //打开上传弹窗
    openUpload () {
      var user = commonUtils.getUser();
      var flag = localStorage.getItem(user.id + 'uploadShow');
      //如果已经点击过，或者是不再提示
      if (flag) {
        if (this.pair.length) {
          this.$refs.teamNotice.noticeShow = true;
          this.$refs.teamNotice.noticeTxt = this.$t('language.teamTransfer.cleanCurrent');
          this.$refs.teamNotice.source = 'upload';
          return;
        }
        let input_file = document.getElementById("openFile");
        input_file.click();
        return;
      }
      //如果没有点击过
      if (this.pair.length) {
        this.$refs.teamNotice.noticeShow = true;
        this.$refs.teamNotice.noticeTxt = this.$t('language.teamTransfer.cleanCurrent');
        this.$refs.teamNotice.source = 'upload';
        return;
      }
      this.$refs.uploadCSV.uploadCsvShow = true;
    },
    getDropDown(){
      var name='drop-team-down';
      if(!this.fromDrives.length||!this.aimDrives.length||this.autoLoading){
          name='drop-team-down';
          return name;
      }
      if(this.showDown){
          name ='icon-util dropdown-purple';
      }else{
          name='icon-util drop-down-up dowm-up-position'
      }
      return name;
    },
    //上传文件change事件
    clickUploadFileChange (event) {
      let file = event.target.files;
      var user = commonUtils.getUser();
      var _self = this;
      this.autoLoading = true;
      var formData = new FormData();
      var drivePath = this.fromDrives[0].rootId;
      var drivePath2 = this.aimDrives[0].rootId;
      if(this.fromDrives[0].appName == 'dropbox4Business'){
          drivePath='Members';
      }
       if(this.aimDrives[0].appName == 'dropbox4Business'){
          drivePath2='Members';
      }
      formData.append('driveId', this.fromDrives[0].id);
      formData.append('drivePath',drivePath);
      formData.append('driveId2', this.aimDrives[0].id);
      formData.append('drivePath2', drivePath2);
      formData.append('file', file[0]);
      axios({
        url: commonstate.apiUrl + "/business_transfer/csv_parse",
        method: 'post',
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
      }).then(res => {
        if (res.status == 200) {
          _self.autoLoading = false;
          var result = this.Utils.decrypt(res.data);
          if (result.code == 200) {
            _self.pair = result.data;
          } else {
            _self.$toast({
              text: _self.$t('language.teamTransfer.matchCsv'),
              type: 'fail',
              idValue: "leftBan"
            });
          }
        } else {
          _self.$toast({
            text: _self.$t('language.teamTransfer.matchCsv'),
            type: 'fail',
            idValue: "leftBan"
          });
        }
        //上传列表置为空
        if (_self.$refs.uploadFile && _self.$refs.uploadFile.value) {
          _self.$refs.uploadFile.value = null;
        }
      }).catch(err => {
        _self.$toast({
          text: _self.$t('language.teamTransfer.matchCsv'),
          type: 'fail',
          idValue: "leftBan"
        });
      })
    },
    //提交传输任务名
    submiTransfertName () {
      if (this.$refs.editInput.value.length > 255) {
        this.$refs.editInput.value = this.$refs.editInput.oldNameValue;
        this.$toast({
          text: this.$t('language.taskList.taskNameRule'),
          type: 'fail',
          idValue: "cloudTransfer"
        });
        return false;
      }
      commonUtils.submiTaskName(this);
    },
    //打开目标
    open (item) {
      item.open = !item.open;
      this.$forceUpdate();
    },
    openAim (item) {
      item.aimOpen = !item.aimOpen;
      this.$forceUpdate();
    },
    //打开传输目标弹窗
    transferAimDialogShow (value) {
      if (value == 'out') {
        if (this.aimDrives.length) {
          return;
        }
      }else{
           if (!this.aimDrives.length) {
          return;
        }
      }
      if (this.aimDrives.length) {
        this.$refs.transferSourceDialog.checkItem = this.aimDrives[0];
      } else {
        this.$refs.transferSourceDialog.checkItem = null;
      }
      this.$refs.transferSourceDialog.taskSingleShow = true;
      this.$refs.transferSourceDialog.source = false;
    },
    // 打开目录弹窗
    transferSourceDialogShow (value) {
      if (value == 'out') {
        if (this.fromDrives.length) {
          return;
        }
      }else{
           if (!this.fromDrives.length) {
          return;
        }
      }
      if (this.fromDrives.length) {
        this.$refs.transferSourceDialog.checkItem = this.fromDrives[0];
      } else {
        this.$refs.transferSourceDialog.checkItem = null;
      }
      this.$refs.transferSourceDialog.taskSingleShow = true;
      this.$refs.transferSourceDialog.source = true;
    },
    //删除多源选中框里的数据
    removeItem (index, id) {
      let that = this;
      //删除数据
      this.mulitDrives.splice(index, 1);
      //取消该项的选中
      this.$refs.transferSourceDialog.$refs.tree.setChecked(id, false);
      $.each(this.$refs.transferSourceDialog.checkedNodes, function (nodeIndex, nodeItem) {
        if (nodeItem.id == id) {
          that.$refs.transferSourceDialog.checkedNodes.splice(nodeIndex, 1);
          return false;
        }
      });
    },
    //打开设置弹窗
    openOptionsDialog () {
      //显示第一页
      this.$refs.transferOptionsDialog.activeName = "first";
      this.$refs.transferOptionsDialog.optionDialogShow = true;
      this.$refs.transferOptionsDialog.source = 'teamTransfer';
      if (!this.$refs.transferOptionsDialog.$refs.tab3.items.length) {
        this.$refs.transferOptionsDialog.$refs.tab3.radioCurrent = 0;
      }
    },
    //打开设置时间弹窗
    openSchduleDialog () {
        this.$refs.transferScheduleDialog.taskSchduleShow = true;
        this.$refs.transferScheduleDialog.initPopup();
    },
    //当用户取消选择时间设置时默认传参数为‘Now’
    checkedOpen () {
      if (this.checkedSchedule) {
        this.checkedSchedule = false;
        this.addTaskShow = false;
        this.pSchedules = {
          type: "Now"
        }
        this.clearAllTableData();
      } else {
        this.$refs.transferScheduleDialog.$refs.daily.checkArr = [0];
        this.openSchduleDialog();
      }
    },
    //清除界面数据
    clearAllTableData () {
      this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
      this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
      this.$refs.transferScheduleDialog.$refs.daily.checkArr = [];
      this.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
      this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = true;
      this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = true;
      this.$refs.transferScheduleDialog.oldSchedules = {};
      this.$refs.transferScheduleDialog.schedules = {};
    },
    matchfileType (fileName) {
      return commonUtils.matchfileTypes(fileName);
    },
    transferNow () {
      //判断是否是临时用户，然后提醒用户进行绑定邮箱
      let user = commonUtils.getUser();
      if (commonUtils.testUserIsTourist(user)) {
        this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
        return false;
      }
      let that = this;
      var executeData;
      //如果用户流量不足，则显示付费升级弹窗
      let usedTraffic = user.usedBytes;
      // if (user.vip && user.payLevel > 1) {
      //   usedTraffic = user.payUsedTraffic;
      // }
      if(!user.vip && this.pair.length>3){
        var upgradeNewDialog = this.$refs.upgradeNewDialog;
        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_subtasks');
        upgradeNewDialog.curItem = 'subtasks';
        upgradeNewDialog.isShow = true;
        return false;
      }
       if(this.pair.length>1000){
            that.$toast({
            text: this.$t('language.teamTransfer.mostTasks'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
           return false;
       }
      if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
        var upgradeNewDialog = this.$refs.upgradeNewDialog;
        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
        upgradeNewDialog.curItem = 'traffic';
        upgradeNewDialog.isShow = true;
        return false;
      }
      //如果用户源和目标都选择了
      if (this.fromDrives.length && this.aimDrives.length) {
        var ftItems = this.packFtItems();
        let addData = new taskTransferUtils.businessTransfer(user.id, this.inputValue, ftItems, this.pOptions, {
          type: 'Now',
          clientTime: commonUtils.getNowDateFormat(),
        });
        addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
        if (!addData.n) {
          this.$refs.editInput.cancelTaskName();
          addData.n = this.$refs.editInput.oldNameValue;
        }
        //开始传输数据
        this.$nextTick(function () {
          this.transferNowRequest(addData);
        });
      } else if (!this.fromDrives.length) {
        this.boxFrom = "box-shake";
        setTimeout(() => {
          this.boxFrom = "box-shakeOrigin";
        }, 100);
      } else if (!this.aimDrives.length) {
        this.boxTo = "box-shake";
        setTimeout(() => {
          this.boxTo = "box-shakeOrigin";
        }, 100);
      }
    },
    //立即企业传输请求
    transferNowRequest (addData) {
      let that = this;
      if (that.addTaskFlag) {
        that.addTaskFlag = false;
        that.loading = true;
        if (!this.pair.length) {
          that.$toast({
            text: this.$t('language.teamTransfer.nosourceAccount'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          that.loading = false;
          that.addTaskFlag = true;
          return;
        }
        //如果整体的未分组的数据超过5000，则显示弹窗
        if (this.$store.state.taskListNotGropArr.length >= 5000) {
          that.$toast({
            text: this.$t('language.exception.maxTaskRemind'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          that.loading = false;
          that.addTaskFlag = true;
          return false;
        }
        //调用添加数据接口
        that.Utils.doBusinessTransferRequest('create', addData).then(res => {
          that.addTaskFlag = true;
          //添加成功后获取单个任务的详情信息
          res.task.status = 'Waiting';
          delete res.task.result;
          that.pair = [];
          that.fromDrives =[];
          that.aimDrives = [];
          that.getBusinessTransfer(res.task);
          //添加数据成功
          // taskListUtils.exeSuccessEnd('transferFlow','taskList',[res.task],that);
          that.loading = false;
        }).catch(err =>{
			that.addTaskFlag = true;
			for (var i = 0; i < that.pair.length; i++) {
			    if( that.pair[i].fromItem){
			        that.pair[i].from = that.pair[i].fromItem[0].fromEmail;
			    }
			    if( that.pair[i].toItem){
			        that.pair[i].to = that.pair[i].toItem[0].toEmail;
			    }
			  delete that.pair[i].fromItem;
			  delete that.pair[i].toItem;
			}
			that.loading = false;
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "cloudTransfer"
			});
		});
      }
    },
    //获取企业云盘单个信息
    getBusinessTransfer (task) {
      var data = {
        id: task.id,
        ud: commonUtils.getUser().id
      }
      var that = this;
      this.Utils.doBusinessTransferRequest('get', data).then(res => {
        task.type = 1;
        task.sources = res.tasks;
        taskListUtils.exeSuccessEnd('transferFlow', 'taskList', [task], that);
      }).catch(err =>{
		  if (err.reason) {
		    err = that.$t('language.exception.' + err.reason)
		  }
		  that.$toast({
		    text: err,
		    type: 'fail',
		    idValue: "cloudTransfer"
		  });
	  });
    },
    //仅仅添加定时任务
    transferAddTask () {
         let that = this;
      //判断是否是临时用户，然后提醒用户进行绑定邮箱
      let user = commonUtils.getUser();
      if (commonUtils.testUserIsTourist(user)) {
        this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
        return false;
      }
     if(!user.vip && this.pair.length>3){
      var upgradeNewDialog = this.$refs.upgradeNewDialog;
      upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_subtasks');
      upgradeNewDialog.curItem = 'subtasks';
      upgradeNewDialog.isShow = true;
      return false;
      }
       if(this.pair.length > 1000){
            that.$toast({
            text: this.$t('language.teamTransfer.mostTasks'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
           return false;
       }
      if (this.fromDrives.length && this.aimDrives.length) {
       
        //流量不足弹窗提醒
        let usedTraffic = user.usedBytes;
        // if (user.vip && user.payLevel > 1) {
        //   usedTraffic = user.payUsedTraffic;
        // }
        if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
          var upgradeNewDialog = this.$refs.upgradeNewDialog;
          upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
          upgradeNewDialog.curItem = 'traffic';
          upgradeNewDialog.isShow = true;
          return false;
        }
        if (!this.pair.length) {
          that.$toast({
            text: this.$t('language.teamTransfer.nosourceAccount'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          that.loading = false;
          return;
        }
        var ftItems = this.packFtItems();
        var ftItemsCopy = Object.assign([],ftItems);
        let addData = new taskTransferUtils.businessTransfer(user.id, this.inputValue, ftItemsCopy, this.pOptions, this.pSchedules);
        addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
        if (this.$store.state.taskListNotGropArr.length >= 5000) {
          that.$toast({
            text: this.$t('language.exception.maxTaskRemind'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          that.loading = false;
          return false;
        }
        if (!addData.n) {
          this.$refs.editInput.cancelTaskName();
          addData.n = this.$refs.editInput.oldNameValue;
        }
        // if (addData.fromItems.length >= 11 && addData.options.email) {
        //     this.$refs.noticeDialog.noticeShow = true;
        //     this.$refs.noticeDialog.transferFlag = 1;
        //     this.$refs.noticeDialog.addData = addData;
        // } else {
        this.$nextTick(function () {
          this.doAddTasksRequest(addData);
        });
        //}
      } else if (!this.fromDrives.length) {
        this.boxFrom = "box-shake";
        setTimeout(() => {
          this.boxFrom = "box-shakeOrigin";
        }, 100);
      } else if (!this.aimDrives.length) {
        this.boxTo = "box-shake";
        setTimeout(() => {
          this.boxTo = "box-shakeOrigin";
        }, 100);
      }
    },
    packFtItems () {
      var ftItems = [];
      var fromItems = [];//装入所有来源的项
      var aimItems = [];//装入所有目标项
      var fromMembers = this.fromDrives[0].data.members;
      var aimMenbers = this.aimDrives[0].data.members;
      var pairCopy = Object.assign([], this.pair);
      //匹配时去掉未成对的项目
      this.pairCopyValue = Object.assign([], pairCopy);
      for (var m = 0; m < fromMembers.length; m++) {
        fromItems = fromItems.concat(fromMembers[m].items);
      }
      for (var n = 0; n < aimMenbers.length; n++) {
        aimItems = aimItems.concat(aimMenbers[n].items);
      }
      for (var j = 0; j < pairCopy.length; j++) {
        if (pairCopy[j] &&!pairCopy[j].from) {
          pairCopy.splice(j, 1);
        }
        if (pairCopy[j] &&!pairCopy[j].to) {
          pairCopy.splice(j, 1);
        }
      }
      for (var i = 0; i < pairCopy.length; i++) {
        var checkSourceItem;
        var paramItem = pairCopy[i];//取出数组中的一项
        for (var k = 0; k < fromItems.length; k++) {
          if (fromItems[k].email == paramItem.from) {
            checkSourceItem = fromItems[k];
          }
        }
        var checkAimItem;//目标项
        for (var q = 0; q < aimItems.length; q++) {
          if (aimItems[q].email == paramItem.to) {
            checkAimItem = aimItems[q];
          }
        }
        paramItem.fromItem = [];
        var fromNodes = [];
        var fromNode = {
          fileId: checkSourceItem.id,
          filename: checkSourceItem.name
        }
        var fromItemPnode = {
          fileId: this.fromDrives[0].rootId,
          filename: this.fromDrives[0].name
        }
        fromNodes.push(fromNode);
        fromNodes.push(fromItemPnode);
        paramItem.fromItem[0] = {
          driveId: this.fromDrives[0].id,
          driveType: this.fromDrives[0].driveType,
          fileId: checkSourceItem.id,
          filename: checkSourceItem.name,
          isDir: true,
          pid: this.fromDrives[0].rootId,
          nodes: fromNodes,
          fromEmail: checkSourceItem.email
        }
        paramItem.toItem = [];
        var aimNodes = [];
        var aimNode = {
          fileId: checkAimItem.id,
          filename: checkAimItem.name
        }
        var aimItemPnode = {
          fileId: this.aimDrives[0].rootId,
          filename: this.aimDrives[0].name
        }
        aimNodes.push(aimNode);
        aimNodes.push(aimItemPnode);
        paramItem.toItem[0] = {
          driveId: this.aimDrives[0].id,
          driveType: this.aimDrives[0].driveType,
          fileId: checkAimItem.id,
          filename: checkAimItem.name,
          isDir: true,
          pid: this.aimDrives[0].rootId,
          nodes: aimNodes,
          toEmail: checkAimItem.email
        };
        ftItems.push(paramItem);
      }
        var ftItemsCopy=[];
        for(var i=0;i<ftItems.length;i++){
            var itemCopy = {};
            itemCopy.fromItem = ftItems[i].fromItem;
            itemCopy.toItem = ftItems[i].toItem;
            ftItemsCopy.push(itemCopy);
        }
      return ftItemsCopy;
    },
    //添加传输任务并立即执行
    addTransferNow () {
      //判断是否是临时用户，然后提醒用户进行绑定邮箱
      let user = commonUtils.getUser();
      if (commonUtils.testUserIsTourist(user)) {
        this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
        return false;
      }
      if (this.fromDrives.length && this.aimDrives.length) {
        let that = this;
        //流量不足弹窗提醒
        let usedTraffic = user.usedBytes;
        // if (user.vip && user.payLevel > 1) {
        //   usedTraffic = user.payUsedTraffic;
        // }

        if (!this.pair.length) {
          that.$toast({
            text: this.$t('language.teamTransfer.nosourceAccount'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          that.loading = false;
          return;
        }
        if(!user.vip && this.pair.length>3){
          var upgradeNewDialog = this.$refs.upgradeNewDialog;
          upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_subtasks');
          upgradeNewDialog.curItem = 'subtasks';
          upgradeNewDialog.isShow = true;
          return false;
       }
       if(this.pair.length>1000){
            that.$toast({
            text:  this.$t('language.teamTransfer.mostTasks'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
           return false;
       }
       this.loading=true;
        if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
          var upgradeNewDialog = this.$refs.upgradeNewDialog;
          upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
          upgradeNewDialog.curItem = 'traffic';
          upgradeNewDialog.isShow = true;
          return false;
        }
        var ftItems = this.packFtItems();
        let addData = new taskTransferUtils.businessTransfer(user.id, this.inputValue, ftItems, this.pOptions, this.pSchedules);
        addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
        if (this.$store.state.taskListNotGropArr.length >= 5000) {
          that.$toast({
            text: this.$t('language.exception.maxTaskRemind'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          that.loading = false;
          return false;
        }
        if (!addData.n) {
          this.$refs.editInput.cancelTaskName();
          addData.n = this.$refs.editInput.oldNameValue;
        }
        // if (addData.fromItems.length >= 11 && addData.options.email) {
        //     this.$refs.noticeDialog.noticeShow = true;
        //     this.$refs.noticeDialog.transferFlag = 2;
        //     this.$refs.noticeDialog.addData = addData;
        // } else {
        this.$nextTick(() => {
          this.addTaskAndTransferNowRequest(addData);
        });
        //}
      } else if (!this.fromDrives.length) {
        this.boxFrom = "box-shake";
        setTimeout(() => {
          this.boxFrom = "box-shakeOrigin";
        }, 100);
      } else if (!this.aimDrives.length) {
        this.boxTo = "box-shake";
        setTimeout(() => {
          this.boxTo = "box-shakeOrigin";
        }, 100);
      }
    },
    //添加任务并立即传输请求
    addTaskAndTransferNowRequest (addData) {
      let that = this;
      let executeData;
      if (that.addTaskFlag) {
        that.addTaskFlag = false;
        that.Utils.doBusinessTransferRequest('create', addData).then(res => {
          that.addTaskFlag = true;
          executeData = {
            id: res.task.id,
            ud: commonUtils.getUser().id
          }
          taskListUtils.addLength(that);
          that.doExeCuteTasksRequest(executeData, res.task);
          that.checkedSchedule = false;
          that.loading = false;
        }).catch(err =>{
			that.loading = false;
			that.addTaskFlag = true;
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "cloudTransfer"
			});
		});
      }
    },
    doAddTasksRequest (addData) {
      let that = this;
      if (that.addTaskFlag) {
        that.loading = true;
        that.addTaskFlag = false;
        that.Utils.doBusinessTransferRequest('create', addData).then(res => {
          that.pair=[];
          that.aimDrives=[];
          that.fromDrives=[]
          that.getBusinessTransfer(res.task);
          // taskListUtils.exeSuccessEnd('transferFlow','taskList',res.tasks,that);
        }).catch(err =>{
			that.addTaskFlag = true;
			that.loading = false;
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "cloudTransfer"
			});
		});
      }
    },
    doExeCuteTasksRequest (executeData, task) {
      let that = this;
      if (that.addTaskFlag) {
        that.loading = true;
        that.addTaskFlag = false;
        that.Utils.doBusinessTransferRequest('execute', executeData).then(res => {
          that.addTaskFlag = true;
          that.pair=[];
          that.fromDrives=[];
          that.aimDrives=[];
          // $.each(tasks,function(i,item){
          task.status = 'Waiting';
          //});
          that.getBusinessTransfer(task);
          // taskListUtils.exeSuccessEnd('transferFlow','taskList',tasks,that);
        }).catch(err =>{
			that.addTaskFlag = true;
			that.loading = false;
			if (err.reason) {
			  err = that.$t('language.exception.' + err.reason)
			}
			that.$toast({
			  text: err,
			  type: 'fail',
			  idValue: "cloudTransfer"
			});
		});;
      }
    },
    clearPageChoose () {
      let that = this;
      that.mulitDrives = [];
      that.singleDrives = {};
      that.hasSelectItemsMore = false;
      that.hasSelectItems = false;
      that.hasSelect = true;
      that.checkedSchedule = false;
      that.addTaskShow = false;
      let sourceDialog = that.$refs.transferSourceDialog;
      let aimDialog = that.$refs.transferAimsDialog;
      sourceDialog.checkedNodes = [];
      that.$refs.transferAimsDialog.checkedNodes = [];
      that.$store.state.syncClickItem = -1;
      that.$store.state.clickItem = -1;
      that.$store.state.syncArr = [];
      that.$store.state.arr = [];
      that.fromDrives = [];
      that.aimDrives = [];
      let div1 = sourceDialog.$refs['elscrollbar'].wrap;
      let div2 = aimDialog.$refs['elscrollbar'].wrap;
      that.$nextTick(() => {
        div1.scrollTop = 0;
        div2.scrollTop = 0;
      });
      sourceDialog.scrollTopValue = 0;
      aimDialog.scrollTopValue = 0
      that.$refs.transferOptionsDialog.clearAllData();
      that.$refs.transferScheduleDialog.initPopup();
    },
    autoMatch () {
      this.checkSourceItem = null;
      this.checkAimItem = null;
      if (!this.fromDrives.length || !this.aimDrives.length) {
        return;
      }
      if (this.pair.length) {
        this.$refs.teamNotice.noticeShow = true;
        this.$refs.teamNotice.source = 'autoMatch';
        this.$refs.teamNotice.noticeTxt = this.$t('language.teamTransfer.combinations');
        return;
      }
      var user = commonUtils.getUser();
      var dp;
      var dp2;
      dp = this.fromDrives[0].rootId;
      dp2 = this.aimDrives[0].rootId;
      if(this.fromDrives[0].appName == 'dropbox4Business'){
          dp='Members';
      }
       if(this.aimDrives[0].appName == 'dropbox4Business'){
          dp2='Members';
      }
      //自动匹配数据
      var param = {
        dd: this.fromDrives[0].id,
        dp: dp,
        dd2: this.aimDrives[0].id,
        dp2: dp2,
        ud: user.id
      }
      this.autoLoading = true;
      var _self = this;
      this.Utils.doBusinessTransferRequest('whole_matching', param).then(res => {
        if (res.length) {
          _self.pair = res;
        } else {
          _self.$toast({
            text: _self.$t('language.teamTransfer.noAccount'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
        }
        _self.autoLoading = false;
      }).catch(err =>{
		  _self.autoLoading = false
		  if (err.reason) {
		    err = _self.$t('language.exception.' + err.reason)
		  }
		  _self.$toast({
		    text: err,
		    type: 'fail',
		    idValue: "cloudTransfer"
		  });
	  });
    },
    downLoad () {
      if (!this.pair.length) {//如果没有配对组，则报错
        this.$toast({
          text: this.$t('language.teamTransfer.nosourceAccount'),
          type: 'fail',
          idValue: "cloudTransfer"
        });
        return;
      }
      var pairCopy = Object.assign([], this.pair);
      if (pairCopy.length==1) {
        if (!pairCopy[0].from) {
          this.$toast({
            text: this.$t('language.teamTransfer.nosourceAccount'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          return;

        }
        if (!pairCopy[0].to) {
          this.$toast({
            text: this.$t('language.teamTransfer.nosourceAccount'),
            type: 'fail',
            idValue: "cloudTransfer"
          });
          return;

        }
      }
      var user = commonUtils.getUser();
      var param = {
        tfm: JSON.stringify(this.pair)
      }
      var url = commonstate.apiUrl + "/business_transfer/csv_download/";
      this.postExcelFile(param, url);
    },
    // 导出excel
    postExcelFile (params, url) {
      // params是post请求需要的参数，url是请求url地址
      var form = document.createElement('form');
      form.style.display = 'none';
      form.action = url;
      form.method = 'post';
      document.body.appendChild(form);
      form.enctype = "multipart/form-data";
      // 动态创建input并给value赋值
      for (var key in params) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      }
      form.submit();
      form.remove();
    },
    deletePair () {
      if (!this.pair.length) {
        return;
      }
      this.$refs.teamNotice.source = 'delete';
      this.$refs.teamNotice.noticeShow = true;
      this.$refs.teamNotice.noticeTxt = this.$t('language.teamTransfer.cleanAll');
    },
    //选择源项目
    checkSource (item) {
      var that = this;
      this.checkSourceItem = item;
      if (!this.pair.length) {
        var param = {
          from: this.checkSourceItem.email
        }
        this.pair.push(param);
        this.$forceUpdate();
        return;
      }
      var newItem;//最新产生的匹配项
      for (var i = 0; i < this.pair.length; i++) {
        var item = this.pair[i];
        if (!item.from) {//该项没有源项目
          if (item.to) {//判断该项是否还有目标目录
            newItem = Object.assign({}, item);
            newItem.from = this.checkSourceItem.email;
            //进行判断是否有重复的
            for (var j = 0; j < this.pair.length; j++) {
              if (newItem.from == this.pair[j].from && newItem.to == this.pair[j].to) {//表明js中已经存在该项
                this.$toast({
                  text: this.$t('language.teamTransfer.alreadyAdd'),
                  type: 'notice',
                  idValue: 'rightContBan',
                  learnMoreShow: false
                });
                 setTimeout(() => {
                  that.checkSourceItem = null;
                }, 200);
                return;
              }
              if (j == this.pair.length - 1) {
                item.from = this.checkSourceItem.email;//如果遍历结束还未发现相同的项目
                setTimeout(() => {
                  that.checkSourceItem = null;
                  that.checkAimItem = null;
                }, 200);

                return;
              }
            }
          } else {
            item.from = this.checkSourceItem.email;
            setTimeout(() => {
              that.checkSourceItem = null;
            }, 200);

            return;
          }
        } else {
          //如果该项有源目录但是没有目标目录
          if (!item.to) {//则执行替换操作
            item.from = this.checkSourceItem.email;
            return;
          }
        }
        if (i == this.pair.length - 1) {
          var param = {
            from: this.checkSourceItem.email
          }
          this.pair.push(param);
          this.$forceUpdate();
          //this.checkSourceItem = null;
          return;
        }

      }
    },
    checkAim (item) {
      var that = this;
      //如果配对数组为空
      this.checkAimItem = item;
      if (!this.pair.length) {
        var param = {
          to: this.checkAimItem.email
        }
        this.pair.push(param);
        this.$forceUpdate();
        return;
      }
      var newItem;//最新产生的匹配项
      for (var i = 0; i < this.pair.length; i++) {
        var item = this.pair[i];
        if (!item.to) {
          if (item.from) {//判断该项是否还有源目录
            newItem = Object.assign({}, item);
            newItem.to = this.checkAimItem.email;
            //进行判断是否有重复的
            for (var j = 0; j < this.pair.length; j++) {
              if (newItem.from == this.pair[j].from && newItem.to == this.pair[j].to) {//表明js中已经存在该项
                this.$toast({
                  text: this.$t('language.teamTransfer.alreadyAdd'),
                  type: 'notice',
                  idValue: 'rightContBan',
                  learnMoreShow: false
                });
                 setTimeout(() => {
                  that.checkAimItem = null;
                }, 200);
                return;
              }
              if (j == this.pair.length - 1) {
                item.to = this.checkAimItem.email;//如果遍历结束还未发现相同的项目
                this.$forceUpdate();
                setTimeout(() => {
                  that.checkAimItem = null;
                  that.checkSourceItem = null;
                }, 200);
                return;
              }
            }
          } else {
            item.to = this.checkAimItem.email;
            this.$forceUpdate();
            setTimeout(() => {
              that.checkAimItem = null;
            }, 200);

            return;
          }

        } else {
          //  //如果该项有目标目录但是没有源目录
          if (!item.from) {//则执行替换操作
            item.to = this.checkAimItem.email;
            return;
          }
        }
        if (i == this.pair.length - 1) {
          var param = {
            to: this.checkAimItem.email
          }
          this.pair.push(param);
          this.$forceUpdate();
          //this.checkAimItem = null;
          return;
        }
      }
    }

  },
  filters: {
    ellipsisNavi (value) {

    }
  }
};
</script>

<style>
.transfer-right-body {
    width: 100%;
    height: calc(100% - 90px);
    /*no*/
    background-color: #f2f7fe !important;
    position: relative;
    top: 90Px;
    overflow-x:hidden;
}

/*定义滑块，内阴影及圆角*/

.transfer-right-body::-webkit-scrollbar {
    width: 9px;
    /*no*/
    height: 9px;
    /*no*/
    background-color: #fff;
}

.transfer-right-body::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

#cloudTransfer .el-loading-spinner i {
    color: #999999;
}

#cloudTransfer .el-loading-spinner {
    font-size: 45px;
    /*no*/
}
.team-task-box-middle {
    width: calc(53% - 60Px);
    /*no*/
    height: 93%;
    /*no*/
    float: left;
    margin: 0 30Px;
    position: relative;
    border: 8Px solid #e3ecfe;
    background: #fff;
  
   
}
.team-cursor{
    cursor: pointer;
}
.team-transfer-box {
    width: calc(23% - 20px);
    /*no*/
    height:93%;
    min-height: 276px;
    /*no*/
    background: #fff;
    border: 8px solid #e3ecfe;
    /*no*/
    float: left;
    position: relative;
    margin: 0;
    transition: transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
    /*no*/
    transition-property: transform, -webkit-transform;
    transition-duration: 0.1s, 0.1s;
    transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1), cubic-bezier(0.645, 0.045, 0.355, 1);
    /*no*/
    overflow:hidden;
}
.team-definite-operating {
    width: 80%;
    height: 66px;
    /*no*/
    position: absolute;
    margin: auto;
    bottom: 0;
    left: 0;
    right: 0;
    top: 110%;
    font-size: 16px;
    /*no*/
    color: #5562b4;
    padding: 2% 0;
    box-sizing: border-box;
    z-index: 1;
}
.team-box-title{
    width: 100%;
    height: 45Px;
    background: #eef5fd;
    position: relative;
    float: left;
}
.team-box-body{
    width: 100%;
    height: calc(100% - 45Px);
    float: left;
}
.team-title-item{
   width: 35%;
   height: 100%;
   float: left;
   line-height: 45Px;
   color: #a3adbd;
   text-align: left;
   box-sizing: border-box;
   text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.min-type-position{
    position: relative;
    top: 4Px;
    margin-right: 5Px;
}

.team-last-item{
   width: calc(100% - 80%);
   height: 100%;
   float: left;
   line-height: 45Px;
   color: #a3adbd;
   font-size: 14Px;
  
}

/* .dowm-up-position{
    position: relative;
    left: 2Px !important;
} */
.auto-match{
  float:right;
  cursor: pointer;
  color: #4F5DA7;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 72%;
  left: -5Px;
}

.auto-match-dis{
  float:right;
  color: #c4cbe9;
  text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 75%;
  left: -5Px;
}
.middle-box{
float:left;
width:100%;
height:45Px;
color: #6f7886 !important;
}

.middle-box-background{
float:left;
width:100%;
height:45Px;
background: #f5f7fa;
}

.auto-all{
width: 90%;
height: 45Px;
float: right;
position:relative;
left: -10Px;
text-align: left;
}

.team-icon-position{
 float:left;
 position:relative;
 top:15Px;
}

.trash-right{
    float: right;
    border-left: 1Px solid #cdddf5;
    height: 20Px;
    position: relative;
    top: 15Px;
    left: -5Px;
}

.team-task-box-middle .el-loading-mask{
    background: transparent !important;
}
.team-task-box-middle .el-loading-spinner .path{
    stroke-width:4;
    stroke:#4e62b6 !important;
}

.trash-position{
  top:16Px;
  left: -10Px;
}

.title-txt-team{
float:left;
margin-left:20Px;
font-size:20Px;
line-height:30Px;
position:relative;
top:8Px;
color: #a3adbd;
font-weight: normal;
}


.trash-icon{
    float: left;
    margin-left: 8Px;
    color: #4F5DA7;
}
.trash-icon-dis{
    float: left;
    margin-left: 8Px;
    color: #c4cbe9;
}
.csv-box{
    position: absolute;
    width: 115Px;
    height: 105Px;
    background: #fff;
     border: 1Px solid #8a96e3;
     right: -10Px;
     top: 40Px;
     text-align: left;
     z-index: 9999;
    
}
.team-box-all{
    width: 100%;
    height: calc(100% - 40Px);
    overflow: auto;
}
.csv-item{
    width: 100%;
    height: 35Px;
    line-height: 35Px;
    color: #6f7886;
    box-sizing: border-box;
    padding-left: 10Px;
     text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap ;
  position: relative;
}
.csv-item:hover{
    background: #f5f7fa;
}

.add-transfer-txt{
float:left;
width:100%;
text-align: left;
height: 60Px;
line-height: 60Px;
display: flex;
align-items: center;
vertical-align:middle;
color: #5562b4;
}

.add-team-icon-position{
float:left;
margin-left:20Px;
margin-right:10Px;
}

.cloud-txt{
    white-space: nowrap;
}
.cloud-txt:hover{
  text-decoration: underline;
}

.source-title{
  font-size: 16Px;
  float: left;
  line-height: 65Px;
  width: calc(100% - 100Px);
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap ;
  position: relative;
  right: 35Px;
}
.icon-normal-drive{
    float: left;
    position: relative;
    top: -4Px; 
    right: 15Px;
}
.team-refresh{
    width: 30Px;
    height: 30Px;
    float: left;
    position: absolute;
    right: 5Px;
    top: 13Px;
}
.team-box-title .edit:hover {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -833px -298px;
    /*no*/
    cursor: pointer;
     width: 30Px;
    height: 30Px;
    float: left;
    position: absolute;
    right: 5Px;
    top: 13Px;
}
.team-transfer-box .el-scrollbar__bar.is-vertical {
    width: 8px !important;
    /*no*/
}

.team-task-box-middle .el-scrollbar__bar.is-vertical {
    width: 8px !important;
    /*no*/
   
}


.not-open-position{
    top: 10Px !important;
}
.down-triangle-position{
    top: 13Px !important;
}
/* 隐藏横向的滚动条 */
.team-transfer-box .el-scrollbar__bar.is-horizontal {
    height: 0px !important;
    /*no*/
    bottom: 0 !important;
    ;
}
.team-box-item{
    /* width: 100%; */
    /* height: 35Px; */
    line-height: 35Px;
    text-align: left;
    color: #71767e;
    /* float: left; */
    font-size: 14Px;
    white-space: nowrap;
    word-break: keep-all;
    white-space: nowrap;
}
.item-line:hover{
    background: #f5f7fa;
}
.box-litem{
    float: left;
    height: 35Px;
    width: 77%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
}
.team-box-middle-body{
   float:left;
   width:100%;
   max-height:calc(100% - 45Px);
   overflow:auto; 
   padding-top: 8Px;
   box-sizing: border-box;
   overflow-y: auto;
   scrollbar-color: #becae4 #fff;
   scrollbar-width: thin;
}
.team-box-middle-body::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 5px;
    /*no*/
    background-color: rgba(0, 0, 0, 0);
}

.team-box-middle-body::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.team-transfer-close{
    width: 20Px;
    height: 20Px;
    background-position: -2330Px -160Px;
    float: right;
    margin-right: 10Px;
    margin-top: 15Px;
    cursor: pointer;
}

.up-prompt{
    display: none;
    width: 280Px;
    padding: 10Px;
    font-size: 12Px;
    border: 1Px solid #8a96e3;
    position: absolute;
    background: #fff;
    left: 15Px;
    top: 15Px;
    z-index: 999999;
}
.team-box-body ul {
    list-style: none;
    color: #6f7886;
    margin: 0;
    padding-left: 0px;
    /*no*/
    display: block;
    list-style-type: disc;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}

.team-box-body li {
    list-style: none;
    min-width: 240px;
    /*no*/
    text-align: left;
    white-space: nowrap;
    margin: 0;
}
/* .litem-div{
    word-break: keep-all;
    white-space: nowrap;
    min-width: 300Px;
    height: 40Px;
    overflow: hidden;
} */
.item-line{
    height: 40Px;
    width: 100%;
    word-break: keep-all;
    white-space: nowrap;
    line-height: 40Px;
    /* min-width: 460px; */
    /* height: 40px; */
    overflow: hidden;
    cursor: pointer;
}
  
</style>



// WEBPACK FOOTER //
// src/components/workspace/team_transfer.vue